import API from '@/js/API'
window.API = API

import '@/js/lib/request'

Vue.prototype.$message = ELEMENT.Message
Vue.prototype.$MessageBox = ELEMENT.MessageBox

Vue.prototype.bus = new Vue()

import AwesomeSwiper from 'vue-awesome-swiper'
window.AwesomeSwiper = AwesomeSwiper
Vue.use(AwesomeSwiper)

// 引入 i18n 国际化插件
import { i18n } from '@/locales/index'
window.i18n = i18n

// 引入 jquery
import $ from 'jquery'
Vue.prototype.$ = window.Jq = $

// 引入规范css
import 'normalize.css/normalize.css'

// 引入懒加载
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/optimumx/ls.optimumx'
import 'lazysizes/plugins/attrchange/ls.attrchange'

window.lazySizesConfig = lazySizes.cfg || {}
window.lazySizesConfig.constrainPixelDensity = true


import store from '@/js/store/index'
window.store = store

Vue.component('v-app', require('@/js/App.vue').default)
//checkout accordion
Vue.component('v-accordion', require('@/views/checkout/js/components/accordion.vue').default)
Vue.component('v-addressformfoot', require('@/views/checkout/js/components/addressformfoot.vue').default)
//checkout information
// Vue.component('v-expresscheckout', require('@/views/checkout/js/components/expresscheckout.vue').default)

//checkout noavailable
Vue.component('v-noavailable', require('@/views/checkout/js/components/noavailable.vue').default)

//checkout rightshoppingcar
Vue.component('v-checkoutright', require('@/views/checkout/js/components/checkoutright.vue').default)
//checkout rightshoppingcar
Vue.component('v-checkoutnav', require('@/views/checkout/js/components/checkoutnav.vue').default)

Vue.component('v-fclca', require('@/js/components/view/fclca/fclca.vue').default)

Vue.component('v-translate', require('@/js/components/common/translate.vue').default)
Vue.component('v-currencysymbol', require('@/js/components/common/currencysymbol.vue').default)

// 引入公用方法挂入vue
import METHODS from '@/js/methods'
for (const key in METHODS) {
  if (METHODS.hasOwnProperty(key)) {
    Vue.prototype[key] = METHODS[key]
  }
  if (key == 'send_fb_event') {
    //默认像素事件
    METHODS[key]('PageView', {})
  }
}

import defaultImage from '@/images/no-image.gif'
Vue.prototype.defaultImage = defaultImage

if (process.env.MIX_SENTRY_DSN && process.env.MIX_VERSION) {
  import(/* webpackChunkName: "sentry" */ `@/sentry/index`)
}

// 保存配置到全局状态
const { commit } = store

commit({
  type: 'settings/save',
  payload: {
    defaultNoImage: defaultImage,
  },
})

import googleAnalysis from '@/js/lib/ga'

// 谷歌分析插件
if (window.onGoogleAnalysisLoad) {
  const googleAnalysisLoad = (trackId, Ecommerce) => {
    // 保存ga信息
    commit({
      type: 'googleAnalysis/save',
      payload: {
        enable: !!trackId,
        trackId: trackId,
        ecommerce: !!parseInt(Ecommerce || 0, 2),
      },
    })
  }

  window.onGoogleAnalysisLoad(googleAnalysisLoad)

  delete window.onGoogleAnalysisLoad

  // 默认追踪页面
  googleAnalysis.page()
}
window.startup = function (payload = {}) {
  new Vue({
    el: '#app',
    store,
    i18n,
    ...payload,
  })
}
